// extracted by mini-css-extract-plugin
module.exports = {"landing":"Landing_landing__38v7Y","btn":"Landing_btn__3HZLZ"};